import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { environment } from '../../../environments/environment';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-incorrect-captcha-dialog',
    templateUrl: './incorrect-captcha-dialog.html',
})
export class IncorrectCaptchaDialogComponent {

    public mainForm: FormGroup;
    public captchaUrl: string;

    constructor(
        public dialogRef: MatDialogRef<IncorrectCaptchaDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        public loc: LocalizationService) {

    }

    closeDialog(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/dialogs/incorrect-captcha-dialog/incorrect-captcha-dialog.ts